/**
 * Conditional class-name builder.
 *
 * Accepts strings, arrays, and object maps (key -> boolean). Used with CSS
 * Modules so conditional styling stays declarative instead of ternary soup.
 *
 * @param {...unknown} args - Strings, arrays of args, or `{ [className]: boolean }` maps.
 * @returns {string} Space-joined class list.
 */
export function cn(...args: unknown[]): string {
  const classes: string[] = [];

  for (const arg of args) {
    if (!arg) continue;
    if (typeof arg === "string") {
      classes.push(arg);
    } else if (Array.isArray(arg)) {
      classes.push(cn(...arg));
    } else if (typeof arg === "object") {
      const map = arg as Record<string, boolean>;
      for (const key of Object.keys(map)) {
        if (Object.prototype.hasOwnProperty.call(map, key) && map[key]) {
          classes.push(key);
        }
      }
    }
  }

  return classes.join(" ");
}
